import { TextField } from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../common/button/CustomButton';
import { connect } from 'react-redux';
import { reset_password_confirm } from '../../store/actions/auth';
import { isMobile } from 'react-device-detect';


const ResetPasswordConfPage = ({ match,reset_password_confirm }) => {

    const [formData, setFormData] = useState({
        new_password: '',
        re_new_password: ''
    });

    const { new_password, re_new_password } = formData;
    const [success, setsuccess] = useState();
    const [error, seterror] = useState();

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();

        const uid = match.params.uid;
        const token = match.params.token;

        // console.log(new_password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}/i)?.length>0,
        // new_password==re_new_password
        // )
        if(new_password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}/i)?.length>0){
        if(new_password==re_new_password)
           { reset_password_confirm(uid, token, new_password, re_new_password,setsuccess);
            }else{
                seterror('nomatch')
            }}else{
                seterror('invalid')
            }
    };

    // if (requestSent) {
    //     return <Redirect to='/login' />
    // }

    return (
<>

 <div className="container row2" style={{width:'100%',
  justifyContent:'center', textAlign:'center',
  alignItems:'center', marginLeft:'5%'
}}>
    <div    
     className='full-site'
     style={{zIndex:10, minHeight:'500px'}}
    >
<h2>Reset your password</h2>
{success ?
<>
<p style={{textAlign:'center'}}>Your password has been successfully reset.</p>
<div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
      {isMobile ?
      <a href='/open'>
        <CustomButton onClick={()=>{}} color={'pastel'} title={'OPEN GOALQUEST'}
        />
        </a>
        : null}
        </div> 
      </>
:
success==false ?
<>
<p style={{textAlign:'center'}}>Something went wrong.</p>
<div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}><CustomButton onClick={()=>{setsuccess()}} color={'pastel'} title={'TRY AGAIN'}/></div> 
      </>
:
<>

<p style={{textAlign:'center'}}>Please enter a new password.</p>
<div style={{ justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
            <form onSubmit={e => onSubmit(e)} style={{backgroundColor:'#F5F5F5',
        padding:'5%', marginLeft:'10%', marginRight:'10%'}}>
            <div style={{width:'100%'}}>
                   <TextField
                   label="Enter Password" variant="outlined" 
                        className='form-control'
                        type='password'
                        placeholder='New Password'
                        style={{width:'80%', backgroundColor:'white', borderRadius:5}}
                        name='new_password'
                        value={new_password}
                        onChange={e => onChange(e)}
                        minLength='6'
                        required
                    />
                </div>
                <div style={{width:'100%', marginTop:'2%',  marginBottom:'2%'}}>
                <TextField
                         label="Confirm New Password" variant="outlined"
                        type='password'
                        placeholder='Confirm New Password'
                        name='re_new_password'
                        style={{width:'80%', backgroundColor:'white', borderRadius:5}}
                        value={re_new_password}
                        onChange={e => onChange(e)}
                        minLength='6'
                        required
                    />
                </div>
                {error=='invalid' ? 
                <p style={{textAlign:'left',marginLeft:'10%',color:'#FD8982'}}>
                    Please enter a valid password:
                    <li>At least 8 characters</li>
                    <li>At least one number</li>
                    <li>At least one letter</li>
                </p>
                :
                error=='nomatch' ? 
                <p style={{textAlign:'left',marginLeft:'10%',color:'#FD8982'}}>
                Please ensure the passwords match.
            </p>
                : null}
                <div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}><CustomButton onClick={(e)=>{onSubmit(e)}} color={'bright'} title={'RESET PASSWORD'}
      style={{width:'80%',}}
      largebutton={true}/></div> 

            </form>
            </div>
        </>
        }
        </div>
        </div>
        </>
    );
};
const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { reset_password_confirm })(ResetPasswordConfPage);
